function toggleHardcopyPost() {
  const membercardLocation = document.querySelector("#membercard_order_user_data_country");
  const hardcopyHolder = document.querySelector(".js-hardcopy-holder");
  const hardcopyCheckbox = document.querySelector(".js-card-hardcopy-toggle");
  const changeEvent = new Event("change");

  if (hardcopyCheckbox) {
    membercardLocation.addEventListener("change", function (e) {
      if (membercardLocation.value !== "nl") {
        hardcopyCheckbox.checked = false;
        hardcopyCheckbox.dispatchEvent(changeEvent);
        hardcopyHolder.classList.add("hide");
      } else {
        hardcopyHolder.classList.remove("hide");
      }
    });
  }
}

function toggleHardcopyPrice() {
  const hardcopyCheckbox = document.querySelector(".js-card-hardcopy-toggle");
  
  if (hardcopyCheckbox) {
    const receiptPrice = document.querySelector(".stayokay-card-receipt__item--price");
    const receiptLabel = document.querySelector(".stayokay-card-receipt__item--distribution");
    const receipt = document.querySelector(".stayokay-card-receipt--pricing");
    
    hardcopyCheckbox.addEventListener("change", function (e) {
      receipt.style.backgroundColor = "#f2f5f5";
      if (hardcopyCheckbox.checked) {
        receiptPrice.innerHTML = receiptPrice.getAttribute("data-hardcopy-price");
        receiptLabel.querySelector("span").innerHTML = receiptLabel.getAttribute("data-hardcopy-label");
      } else {
        receiptPrice.innerHTML = receiptPrice.getAttribute("data-digital-price");
        receiptLabel.querySelector("span").innerHTML = receiptLabel.getAttribute("data-digital-label");
      }
      setTimeout(function () {
        receipt.style.backgroundColor = "#fff";
      }, 1000);
    });
  }
}


toggleHardcopyPost();
toggleHardcopyPrice();
